import { reportModalActionTypes } from './Constants';
import * as reportModalActions from './Actions';
import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import { processRequest } from '../../../services/Api';
import * as notificationActions from '../../notification/Actions';
import { getReportType } from './Selectors';
import * as errorHandlerActions from '../../errorHandler/Actions';
import i18n from 'i18next';

export default function* () {
	yield all([
		yield takeLatest(
			reportModalActionTypes.GET_REPORT_OPTIONS_REQUEST,
			handleGetReportOptionsRequest,
		),
		yield takeLatest(reportModalActionTypes.SEND_REPORT_REQUEST, handleSendReportRequest),
	]);
}

export function* handleGetReportOptionsRequest({ payload }) {
	try {
		const { data } = yield call(
			processRequest,
			`qna/${payload.data.reportType}_flagging_reasons`,
		);

		yield put(
			reportModalActions.getReportOptionsSuccess({
				reportOptions: data[`qna_${payload.data.reportType}_flagging_reasons`],
			}),
		);
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(reportModalActions.getReportOptionsError());
	}
}

export function* handleSendReportRequest({ payload }) {
	try {
		const reportType = yield select(getReportType);
		yield call(processRequest, `qna/flagged_${reportType}s`, 'POST', payload.data);
		yield put(reportModalActions.sendReportSuccess({ loading: false }));
		yield put(reportModalActions.toggleReportModal({ open: false }));
		yield put(
			notificationActions.createNotification(
				i18n.t('modals.report_modal.report_notification')
			),
		);
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(reportModalActions.sendReportError());
	}
}
